import { Image } from "@custom/schema";
import React from "react";
import VideoInline from "../molecules/VideoInline";
import VideoModalButton from "../molecules/VideoModalButton";
export default function Video(param) {
    var displayInline = param.displayInline, thumbnail = param.thumbnail, url = param.url;
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative mb-7 lg:mb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-10 aspect-h-[5.61]"
    }, displayInline ? /*#__PURE__*/ React.createElement(VideoInline, {
        target: url
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, thumbnail ? /*#__PURE__*/ React.createElement(Image, {
        source: thumbnail,
        className: "rounded-l-2xl !absolute object-cover w-full",
        alt: "Video thumbnail"
    }) : /*#__PURE__*/ React.createElement("img", {
        src: "/images/teaser-bg.png",
        alt: "Video Thumbnail",
        className: "rounded-l-2xl !absolute object-cover w-full"
    }), /*#__PURE__*/ React.createElement(PlayIcon, null), /*#__PURE__*/ React.createElement(VideoModalButton, {
        target: url,
        buttonClasses: "rounded-full focus w-24 h-24 bg-white hover:bg-gray-500 transition-all absolute top-1/2 -translate-y-1/2 inset-x-0 mx-auto z-10 cursor-pointer"
    }))));
}
function PlayIcon() {
    return /*#__PURE__*/ React.createElement("svg", {
        className: "absolute top-1/2 -translate-y-1/2 inset-x-0 mx-auto z-[11] w-12 h-12 pointer-events-none",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#A8A7A7",
        d: "M442.3 677.6l199.4-156.7c5.7-4.5 5.7-13.1 0-17.7L442.3 346.4c-7.4-5.8-18.3-0.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8A7A7",
        d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
    }));
}
